import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Card, Spin, Modal } from 'antd';
import { FaBookmark } from 'react-icons/fa6';
import { IoMdAdd } from 'react-icons/io';
import { IoIosInformationCircle } from 'react-icons/io';
import { HiOutlineDotsVertical } from 'react-icons/hi';
import { FaRegBookmark } from 'react-icons/fa';
import { MdAccessTimeFilled } from 'react-icons/md';
import { IoBookmark, IoBookmarkOutline } from 'react-icons/io5';
import { MdOutlineArrowBackIos } from 'react-icons/md';
import { MdArrowForwardIos } from 'react-icons/md';
import './HomeRecently.css';
import { Dashboard_Recently_Used_Quick_Actions_ActionHandler } from '../../../Redux/Actions/user/DashboardRecentlyUsedQuickActions';
import { Dashboard_Bookmarked_Quick_Actions_ActionHandler } from '../../../Redux/Actions/user/DashboardBookmarkedQuickActions';
import { workspaces_Bookmark_Toggle_ActionHandler } from '../../../Redux/Actions/user/WorkspaceBookmarkToggle';
import { Quick_Action_Delete_Handler } from '../../../Redux/Actions/user/QuickActionDelete';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
const HomeRecently = () => {
    const CurveImg = '/assets/CurveImage.svg';
    const Linear_equal = '/assets/linearEqual.svg';
    const BookMark = '/assets/bookmark.svg';
    let dispatch = useDispatch();
    let Navigate = useNavigate();
    const [modal2Open, setModal2Open] = useState(false);
    const [permissionModalOpen, setPermissionModalOpen] = useState(false);
    const [quickActionCreatedByName, setQuickActionCreatedByName] =
        useState('');
    const [itemToggleState, setItemToggleState] = useState({});
    const [bookMarkedItemToggleState, setBookMarkedItemToggleState] = useState(
        {}
    );
    const [spinningRecentlyUsed, setSpinningRecentlyUsed] = useState(false);
    const [spinningBookmarkedQuick, setSpinningBookmarkedQuick] =
        useState(false);

    const dashboardrecentlyusedquickactionsdata = useSelector(
        (state) =>
            state?.Dashboard_Recently_Used_Quick_Actions_Data
                ?.dashboard_recently_used_quick_actions_data
    );
    const dashboardbookmarkedquickactionsdata = useSelector(
        (state) =>
            state?.Dashboard_Bookmarked_Quick_Actions_Data
                ?.dashboard_bookmarked_quick_actions_data
    );
    const workspacebookmarktoggleData = useSelector(
        (state) =>
            state?.WorkspaceBookmarkToggleData?.workspace_bookmark_toggle_data
    );
    const quickactiondeleteData = useSelector(
        (state) => state?.QuickActionDeleteData?.quick_action_delete_data
    );

    const userSlugData = useSelector(
        (state) => state.SettingsUserProfileData.slug
    );

    const handleToggleBookmark = (qaId) => {
        dispatch(workspaces_Bookmark_Toggle_ActionHandler(qaId));
    };
    useEffect(() => {
        if (workspacebookmarktoggleData) {
            dispatch(Dashboard_Recently_Used_Quick_Actions_ActionHandler());
            dispatch(Dashboard_Bookmarked_Quick_Actions_ActionHandler());
        }
    }, [workspacebookmarktoggleData]);
    useEffect(() => {
        dispatch(Dashboard_Recently_Used_Quick_Actions_ActionHandler());
        dispatch(Dashboard_Bookmarked_Quick_Actions_ActionHandler());
    }, []);
    useEffect(() => {
        if (dashboardrecentlyusedquickactionsdata) {
            setTimeout(() => {
                setSpinningRecentlyUsed(false);
            }, 1000);
        }
    }, [dashboardrecentlyusedquickactionsdata]);
    useEffect(() => {
        if (dashboardbookmarkedquickactionsdata) {
            setTimeout(() => {
                setSpinningBookmarkedQuick(false);
            }, 1000);
        }
    }, [dashboardbookmarkedquickactionsdata]);

    useEffect(() => {
        const handleOutsideClick = (event) => {
            if (
                itemToggleState &&
                !event.target.closest('.vertical-img-logo')
            ) {
                setItemToggleState({});
                setBookMarkedItemToggleState({});
            }
        };

        if (itemToggleState) {
            window.addEventListener('click', handleOutsideClick);
        }

        return () => {
            window.removeEventListener('click', handleOutsideClick);
        };
    }, [itemToggleState, bookMarkedItemToggleState]);

    const handleClick = () => {
        window.dataLayer.push({
            event: 'Navigate',
            buttonName: 'Build a QuickAction',
            userId: JSON.parse(localStorage.getItem('userDetails'))?.id,
            clientId: JSON.parse(localStorage.getItem('userDetails'))
                ?.client_id,
        });
        Navigate('/build-quick-action');
    };
    const handleToggleAction = (itemId) => {
        setItemToggleState((prevToggleState) => ({
            [itemId]: !prevToggleState[itemId],
        }));
        setBookMarkedItemToggleState({});
    };
    const handleToggleActionBook = (itemId) => {
        setBookMarkedItemToggleState((prevToggleState) => ({
            [itemId]: !prevToggleState[itemId],
        }));
        setItemToggleState({});
    };
    const paginationButton = (page_data) => {
        setSpinningRecentlyUsed(true);
        dispatch(
            Dashboard_Recently_Used_Quick_Actions_ActionHandler(page_data)
        );
    };
    const paginationBookmarkButton = (page_data) => {
        setSpinningBookmarkedQuick(true);
        dispatch(Dashboard_Bookmarked_Quick_Actions_ActionHandler(page_data));
    };
    useEffect(() => {
        if (quickactiondeleteData) {
            dispatch(Dashboard_Recently_Used_Quick_Actions_ActionHandler());
            dispatch(Dashboard_Bookmarked_Quick_Actions_ActionHandler());
        }
    }, [quickactiondeleteData]);

    const handleBookmarkDelete = (Id) => {
        if (Id) {
            Swal.fire({
                title: 'Are you sure?',
                text: 'You want to delete this QuickAction?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!',
            }).then((result) => {
                if (result.isConfirmed) {
                    Swal.fire({
                        position: 'centre',
                        icon: 'success',
                        title: 'Bookmarked QuickActions has been deleted successfully',
                        showConfirmButton: false,
                        timer: 1000,
                    });
                    dispatch(Quick_Action_Delete_Handler(Id));
                }
            });
        }
    };
    const handleDelete = (Id) => {
        if (Id) {
            Swal.fire({
                title: 'Are you sure?',
                text: 'You want to delete this QuickAction?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!',
            }).then((result) => {
                if (result.isConfirmed) {
                    Swal.fire({
                        position: 'centre',
                        icon: 'success',
                        title: 'Recently Used has been deleted successfully',
                        showConfirmButton: false,
                        timer: 1000,
                    });
                    dispatch(Quick_Action_Delete_Handler(Id));
                }
            });
        }
    };
    const truncate = (input) =>
        input.length > 5 ? `${input.substring(0, 5)}...` : input;
    return (
        <div className='home-recently'>
            <div className='home-recently-card1'>
                <div>
                    <h4>
                        <MdAccessTimeFilled className='mt-2' /> Recently Used
                    </h4>
                    <h4>
                        <Button
                            icon={<MdOutlineArrowBackIos />}
                            onClick={() =>
                                paginationButton(
                                    dashboardrecentlyusedquickactionsdata?.current_page -
                                        1
                                )
                            }
                            disabled={
                                dashboardrecentlyusedquickactionsdata?.current_page -
                                    1 ===
                                0
                            }
                        />
                        <Button
                            icon={<MdArrowForwardIos />}
                            onClick={() =>
                                paginationButton(
                                    dashboardrecentlyusedquickactionsdata?.current_page +
                                        1
                                )
                            }
                            disabled={
                                dashboardrecentlyusedquickactionsdata?.current_page ===
                                dashboardrecentlyusedquickactionsdata?.last_page
                            }
                        />
                    </h4>
                </div>
                {dashboardrecentlyusedquickactionsdata?.data?.length > 0 ? (
                    <Card
                        bordered={false}
                        className='curve_card custom-scrollbar-curve'>
                        <Spin spinning={spinningRecentlyUsed} size='large'>
                            <div className='home-grid-container'>
                                {dashboardrecentlyusedquickactionsdata?.data &&
                                    dashboardrecentlyusedquickactionsdata?.data.map(
                                        (item, index) => (
                                            <div
                                                key={`recently-${index}`}
                                                style={{
                                                    position: 'relative',
                                                }}>
                                                <img
                                                    src={CurveImg}
                                                    alt=''
                                                    className='curve-image'
                                                />
                                                <img
                                                    src={Linear_equal}
                                                    alt=''
                                                    className='curve-linerequal-img'
                                                />
                                                <div className='curve-linear-icons recent-div-action'>
                                                    <div className='recent-div-action'>
                                                        <IoIosInformationCircle />
                                                    </div>
                                                    <div className='recent-div-action'>
                                                        {item.is_user_bookmarked ? (
                                                            <IoBookmark
                                                                className='workspaces-user-bookmarked-bg workspaces-user-bookmarked-hw'
                                                                onClick={() =>
                                                                    handleToggleBookmark(
                                                                        item.id
                                                                    )
                                                                }
                                                            />
                                                        ) : (
                                                            <IoBookmarkOutline
                                                                className='workspaces-user-bookmarked-hw'
                                                                onClick={() =>
                                                                    handleToggleBookmark(
                                                                        item.id
                                                                    )
                                                                }
                                                            />
                                                        )}
                                                    </div>
                                                    <div
                                                        className='recent-div-action recent-div-action-container'
                                                        onClick={() =>
                                                            handleToggleAction(
                                                                item.id
                                                            )
                                                        }>
                                                        <HiOutlineDotsVertical className='vertical-img-logo' />

                                                        <div
                                                            className={`dropup-form-content recent-form-header-availibility ${
                                                                itemToggleState[
                                                                    item.id
                                                                ]
                                                                    ? 'recent-droup-down-avail-details'
                                                                    : ''
                                                            }`}>
                                                            <div
                                                                className='form-header-text'
                                                                onClick={() => {
                                                                    let navigateObj =
                                                                        {
                                                                            id: item.id,
                                                                        };
                                                                    const queryParams =
                                                                        new URLSearchParams(
                                                                            navigateObj
                                                                        ).toString();
                                                                    const queryParamsObject =
                                                                        Object.fromEntries(
                                                                            new URLSearchParams(
                                                                                queryParams
                                                                            )
                                                                        );
                                                                    if (
                                                                        item?.is_copied &&
                                                                        item?.is_custom
                                                                    ) {
                                                                        setPermissionModalOpen(
                                                                            true
                                                                        );
                                                                    } else if (
                                                                        JSON.parse(
                                                                            localStorage.getItem(
                                                                                'userDetails'
                                                                            )
                                                                        )
                                                                            ?.id ===
                                                                        item?.created_by
                                                                    ) {
                                                                        Navigate(
                                                                            `/edit-quick-action/${queryParamsObject?.id}`
                                                                        );
                                                                    } else {
                                                                        setQuickActionCreatedByName(
                                                                            item?.created_by_name
                                                                        );
                                                                        setModal2Open(
                                                                            true
                                                                        );
                                                                    }

                                                                    //gtm
                                                                    window.dataLayer.push(
                                                                        {
                                                                            event: 'Edit',
                                                                            buttonName:
                                                                                'Edit Quick Action',
                                                                            userId: JSON.parse(
                                                                                localStorage.getItem(
                                                                                    'userDetails'
                                                                                )
                                                                            )
                                                                                ?.id,
                                                                            clientId:
                                                                                JSON.parse(
                                                                                    localStorage.getItem(
                                                                                        'userDetails'
                                                                                    )
                                                                                )
                                                                                    ?.client_id,
                                                                        }
                                                                    );
                                                                }}>
                                                                <span className='form-header-notifications-text'>
                                                                    Edit
                                                                </span>
                                                            </div>
                                                            {userSlugData?.includes(
                                                                'create-delete-qa'
                                                            ) && (
                                                                <>
                                                                    <div className='form-separator-header'></div>
                                                                    <div
                                                                        className='form-header-text'
                                                                        onClick={() => {
                                                                            //gtm
                                                                            window.dataLayer.push(
                                                                                {
                                                                                    event: 'Delete',
                                                                                    buttonName:
                                                                                        'Delete Quick Action',
                                                                                    userId: JSON.parse(
                                                                                        localStorage.getItem(
                                                                                            'userDetails'
                                                                                        )
                                                                                    )
                                                                                        ?.id,
                                                                                    clientId:
                                                                                        JSON.parse(
                                                                                            localStorage.getItem(
                                                                                                'userDetails'
                                                                                            )
                                                                                        )
                                                                                            ?.client_id,
                                                                                }
                                                                            );
                                                                            if (
                                                                                JSON.parse(
                                                                                    localStorage.getItem(
                                                                                        'userDetails'
                                                                                    )
                                                                                )
                                                                                    ?.id ===
                                                                                item?.created_by
                                                                            ) {
                                                                                handleDelete(
                                                                                    item?.id
                                                                                );
                                                                            } else {
                                                                                setQuickActionCreatedByName(
                                                                                    item?.created_by_name
                                                                                );
                                                                                setModal2Open(
                                                                                    true
                                                                                );
                                                                            }
                                                                        }}>
                                                                        <span className='form-header-notifications-text form-text-color'>
                                                                            Delete
                                                                        </span>
                                                                    </div>{' '}
                                                                </>
                                                            )}
                                                        </div>
                                                        {/* </div> */}
                                                    </div>
                                                </div>
                                                <p className='curve-para1'>
                                                    {item.name}
                                                </p>
                                                <p
                                                    className='curve-para2'
                                                    onClick={() => {
                                                        let navigateObj = {
                                                            id: item.id,
                                                        };
                                                        const queryParams =
                                                            new URLSearchParams(
                                                                navigateObj
                                                            ).toString();
                                                        const queryParamsObject =
                                                            Object.fromEntries(
                                                                new URLSearchParams(
                                                                    queryParams
                                                                )
                                                            );
                                                        Navigate(
                                                            `/workspaces/runQuickAction/${queryParamsObject?.id}`
                                                        );

                                                        //gtm
                                                        window.dataLayer.push({
                                                            event: 'Navigate',
                                                            buttonName:
                                                                'Run Quick Action',
                                                            userId: JSON.parse(
                                                                localStorage.getItem(
                                                                    'userDetails'
                                                                )
                                                            )?.id,
                                                            clientId:
                                                                JSON.parse(
                                                                    localStorage.getItem(
                                                                        'userDetails'
                                                                    )
                                                                )?.client_id,
                                                        });
                                                    }}>
                                                    Action
                                                </p>
                                                <hr className='hr-tag' />
                                            </div>
                                        )
                                    )}
                            </div>
                        </Spin>
                    </Card>
                ) : (
                    <Card
                        bordered={false}
                        className='curve_card m-auto custom-scrollbar-curve'>
                        <img src={BookMark} alt='' />
                        <h1>No record found...</h1>
                    </Card>
                )}
            </div>
            <div className='home-recently-card1'>
                <div>
                    <h4>
                        <FaBookmark /> Bookmarked QuickActions
                    </h4>
                    <h4>
                        <Button
                            icon={<MdOutlineArrowBackIos />}
                            onClick={() =>
                                paginationBookmarkButton(
                                    dashboardbookmarkedquickactionsdata?.current_page -
                                        1
                                )
                            }
                            disabled={
                                dashboardbookmarkedquickactionsdata?.current_page -
                                    1 ===
                                0
                            }
                        />
                        <Button
                            icon={<MdArrowForwardIos />}
                            onClick={() =>
                                paginationBookmarkButton(
                                    dashboardbookmarkedquickactionsdata?.current_page +
                                        1
                                )
                            }
                            disabled={
                                dashboardbookmarkedquickactionsdata?.current_page ===
                                dashboardbookmarkedquickactionsdata?.last_page
                            }
                        />
                    </h4>
                </div>
                {dashboardbookmarkedquickactionsdata?.data?.length > 0 ? (
                    <Card
                        bordered={false}
                        className='curve_card custom-scrollbar-curve'>
                        <Spin spinning={spinningBookmarkedQuick} size='large'>
                            <div className='home-grid-container'>
                                {dashboardbookmarkedquickactionsdata?.data?.map(
                                    (item, index) => (
                                        <div
                                            key={`bookmarked-${index}`}
                                            style={{ position: 'relative' }}>
                                            <img
                                                src={CurveImg}
                                                alt=''
                                                className='curve-image'
                                            />
                                            <img
                                                src={Linear_equal}
                                                alt=''
                                                className='curve-linerequal-img'
                                            />
                                            <div className='curve-linear-icons recent-div-action'>
                                                {/* <div className="recent-div-action">
                          <IoIosInformationCircle />
                        </div> */}
                                                <div className='recent-div-action'>
                                                    {item.is_user_bookmarked ? (
                                                        <IoBookmark
                                                            className='workspaces-user-bookmarked-bg workspaces-user-bookmarked-hw'
                                                            onClick={() =>
                                                                handleToggleBookmark(
                                                                    item.id
                                                                )
                                                            }
                                                        />
                                                    ) : (
                                                        <IoBookmarkOutline
                                                            className='workspaces-user-bookmarked-hw'
                                                            onClick={() =>
                                                                handleToggleBookmark(
                                                                    item.id
                                                                )
                                                            }
                                                        />
                                                    )}
                                                </div>
                                                <div
                                                    className='recent-div-action recent-div-action-container'
                                                    onClick={() =>
                                                        handleToggleActionBook(
                                                            item.id
                                                        )
                                                    }>
                                                    <HiOutlineDotsVertical className='vertical-img-logo' />

                                                    <div
                                                        className={`dropup-form-content recent-form-header-availibility ${
                                                            bookMarkedItemToggleState[
                                                                item.id
                                                            ]
                                                                ? 'recent-droup-down-avail-details'
                                                                : ''
                                                        }`}>
                                                        <div
                                                            className='form-header-text'
                                                            onClick={() => {
                                                                let navigateObj =
                                                                    {
                                                                        id: item.id,
                                                                    };
                                                                const queryParams =
                                                                    new URLSearchParams(
                                                                        navigateObj
                                                                    ).toString();
                                                                const queryParamsObject =
                                                                    Object.fromEntries(
                                                                        new URLSearchParams(
                                                                            queryParams
                                                                        )
                                                                    );
                                                                if (
                                                                    JSON.parse(
                                                                        localStorage.getItem(
                                                                            'userDetails'
                                                                        )
                                                                    )?.id ===
                                                                    item?.created_by
                                                                ) {
                                                                    Navigate(
                                                                        `/edit-quick-action/${queryParamsObject?.id}`
                                                                    );
                                                                } else {
                                                                    setQuickActionCreatedByName(
                                                                        item?.created_by_name
                                                                    );
                                                                    setModal2Open(
                                                                        true
                                                                    );
                                                                }
                                                            }}>
                                                            <span className='form-header-notifications-text'>
                                                                Edit
                                                            </span>
                                                        </div>
                                                        {userSlugData?.includes(
                                                            'create-delete-qa'
                                                        ) && (
                                                            <>
                                                                <div className='form-separator-header'></div>
                                                                <div
                                                                    className='form-header-text'
                                                                    onClick={() => {
                                                                        if (
                                                                            JSON.parse(
                                                                                localStorage.getItem(
                                                                                    'userDetails'
                                                                                )
                                                                            )
                                                                                ?.id ===
                                                                            item?.created_by
                                                                        ) {
                                                                            handleBookmarkDelete(
                                                                                item?.id
                                                                            );
                                                                        } else {
                                                                            setQuickActionCreatedByName(
                                                                                item?.created_by_name
                                                                            );
                                                                            setModal2Open(
                                                                                true
                                                                            );
                                                                        }
                                                                    }}>
                                                                    <span className='form-header-notifications-text form-text-color'>
                                                                        Delete
                                                                    </span>
                                                                </div>
                                                            </>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                            <p className='curve-para1'>
                                                {item.name}
                                            </p>
                                            <p
                                                className='curve-para2'
                                                onClick={() => {
                                                    let navigateObj = {
                                                        id: item.id,
                                                    };
                                                    const queryParams =
                                                        new URLSearchParams(
                                                            navigateObj
                                                        ).toString();
                                                    const queryParamsObject =
                                                        Object.fromEntries(
                                                            new URLSearchParams(
                                                                queryParams
                                                            )
                                                        );
                                                    Navigate(
                                                        `/workspaces/runQuickAction/${queryParamsObject?.id}`
                                                    );
                                                }}>
                                                Action
                                            </p>
                                            <hr className='hr-tag' />
                                        </div>
                                    )
                                )}
                            </div>
                        </Spin>
                    </Card>
                ) : (
                    <Card bordered={false} className='home-action-right'>
                        <img src={BookMark} alt='' />
                        <h1>You haven't bookmarked any QuickActions</h1>
                        <p>
                            To bookmark a QuickAction, click on its bookmark
                            ribbon. Your Bookmarked QuickAction will appear
                            here.
                        </p>
                        <div className='home-action-btn'>
                            <Button className='main-api' onClick={handleClick}>
                                <IoMdAdd />
                                Build a QuickAction
                            </Button>
                        </div>
                    </Card>
                )}
            </div>
            <Modal
                title='Restricted Access'
                centered
                open={modal2Open}
                onOk={() => setModal2Open(false)}
                onCancel={() => setModal2Open(false)}>
                <p>
                    The reference data and prompt for this QuickAction has been
                    restricted and can not be viewed or edited.
                    {/* This QuickAction has been created by{' '}
                    <span style={{ fontWeight: '600' }}>
                        {quickActionCreatedByName}
                    </span>
                    . The view for reference data and prompt has been restricted
                    by the owner. For further details, please contact{' '}
                    {quickActionCreatedByName}. */}
                </p>
            </Modal>
            <Modal
                title='Restricted Access'
                centered
                open={permissionModalOpen}
                onOk={() => setPermissionModalOpen(false)}
                onCancel={() => setPermissionModalOpen(false)}>
                <p>You do not have permission to edit this QuickAction.</p>
            </Modal>
        </div>
    );
};

export default HomeRecently;
